import { useGraphqlDelete } from "@bsm/component"

export const useDeleteSignatoryMutation = () => {
  return useGraphqlDelete('signatory')
}
